var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    staticClass: "preview-class",
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      title: _vm.$t("文件列表")
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-spin", {
    attrs: {
      tip: _vm.$t("文件生成中,请耐心等待 不要退出该页面！"),
      spinning: _vm.fileList.length == 0
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      "file-list": _vm.fileList,
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: false
      },
      "list-type": "picture-card"
    },
    on: {
      preview: _vm.handlePreview
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };